<template>
  <div
    v-if="categories.length"
    class="StoryCategoriesList flex flex-col gap-1 font-display text-sm leading-snug text-muted"
  >
    <span
      v-for="cat in categories"
      :key="cat.id"
      class="Category"
    >
      {{ $t('categories.' + cat.id) }}
    </span>
  </div>
</template>

<script>
/**
 * @module StoryCategoriesList
 */
export default {
  name: 'StoryCategoriesList',
  props: {
    categories: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
